<script lang="ts" setup>
const TOTAL_LANDSCAPE_IMAGE_COUNT = 12;
const TOTAL_PORTRAIT_IMAGE_COUNT = 12;

const getImage = useImage();
const { t } = useI18n();
const gameStore = useGameStore();
const infoStore = useInfoStore();

const landscapeImageIndexes = useState('landscapeImageIndexes', () => getRandomArray(TOTAL_LANDSCAPE_IMAGE_COUNT));
const portraitImageIndexes = useState('portraitImageIndexes', () => getRandomArray(TOTAL_PORTRAIT_IMAGE_COUNT));

const landscapeImageIndex = ref(0);
const portraitImageIndex = ref(0);

const getNext = (current: number, total: number) => (current + 1 === total ? 0 : current + 1);

const landscapeImage = computed(() =>
  getImage(`/images/game-background/h-${landscapeImageIndexes.value[landscapeImageIndex.value]}.jpg`, {
    format: 'webp',
  }),
);
const portraitImage = computed(() =>
  getImage(`/images/game-background/v-${portraitImageIndexes.value[portraitImageIndex.value]}.jpg`, { format: 'webp' }),
);

const nextLandscapeImageIndex = computed(() => getNext(landscapeImageIndex.value, TOTAL_LANDSCAPE_IMAGE_COUNT));
const nextPortraitImageIndex = computed(() => getNext(portraitImageIndex.value, TOTAL_PORTRAIT_IMAGE_COUNT));

const nextLandscapeImage = computed(() =>
  getImage(`/images/game-background/h-${landscapeImageIndexes.value[nextLandscapeImageIndex.value]}.jpg`, {
    format: 'webp',
  }),
);
const nextPortraitImage = computed(() =>
  getImage(`/images/game-background/v-${portraitImageIndexes.value[nextPortraitImageIndex.value]}.jpg`, {
    format: 'webp',
  }),
);

const update = () => {
  landscapeImageIndex.value = getNext(landscapeImageIndex.value, TOTAL_LANDSCAPE_IMAGE_COUNT);
  portraitImageIndex.value = getNext(portraitImageIndex.value, TOTAL_PORTRAIT_IMAGE_COUNT);
};

watch(
  () => gameStore.task,
  (v, prev) => {
    if (v && prev) update();
  },
);

watch(
  () => infoStore.pairedGame?.task,
  (v, prev) => {
    if (prev || v) update();
  },
);
</script>

<template>
  <div class="absolute top-0 left-0 right-0 bottom-0 overflow-hidden">
    <Head>
      <Link rel="preload" :href="nextLandscapeImage" as="image" media="(orientation: landscape)" />
      <Link rel="preload" :href="nextPortraitImage" as="image" media="(orientation: portrait)" />
    </Head>

    <Transition mode="in-out" name="fade">
      <picture :key="landscapeImage + portraitImage">
        <source :srcset="landscapeImage" media="(orientation: landscape)" />
        <source :srcset="portraitImage" media="(orientation: portrait)" />
        <img
          :src="getImage('/images/game-background/v-1.jpg', { format: 'webp' })"
          :alt="t('preview_alt')"
          class="fixed object-cover top-0 left-0 right-0 bottom-0 h-full w-full"
        />
      </picture>
    </Transition>
  </div>
</template>

<i18n>
en:
  preview_alt: Background image for the game of tasks

ru:
  preview_alt: Фоновое изображение для игры в фанты

de:
  preview_alt: Hintergrundbild für das Spiel der Verluste

es:
  preview_alt: Imagen de fondo del juego de las pérdidas.

fr:
  preview_alt: Image de fond pour le jeu des forfaits
</i18n>
